// extracted by mini-css-extract-plugin
export default {"Root":"PartnersBottom_Root__GB2IY","Title":"PartnersBottom_Title__OLQpk","List":"PartnersBottom_List__A1kJA","Item":"PartnersBottom_Item__RTW5v"};